

export default function AttachmentsToolbarIcon() {
  return (
    <svg viewBox="0 0 53.61 53.61" height={20}>
      <path
        d="M31.406 18.422l-17.369 17.37a4.692 4.692 0 0 0 0 6.617h0a4.692 4.692 0 0 0 6.617 0l25.64-25.64c3.412-3.412 2.998-8.581-.414-11.993h0c-3.412-3.412-8.581-3.825-11.993-.414L6.593 31.656c-4.549 4.549-4.549 11.993 0 16.542h0c4.549 4.549 11.993 4.549 16.542 0L50.43 20.903"
        fill="none"
        stroke="#14a085"
        strokeWidth={4}
        strokeLinecap="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
